import { DmStagingApiError } from './dm-staging.js';
const request = async (url, init) => {
    let response;
    try {
        response = await fetch(url, { credentials: 'include', ...init });
    }
    catch {
        throw new DmStagingApiError('unavailable', 'No pudimos consultar la resolución DM.');
    }
    const body = await response.json().catch(() => null);
    if (!response.ok)
        throw new DmStagingApiError(response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : response.status === 400 || response.status === 409
                    ? 'invalid'
                    : 'unavailable', body?.message ?? 'No pudimos resolver la excepción DM.');
    return body;
};
export async function getDmResolutionCandidates(base, rowId) {
    const body = await request(`${base.replace(/\/$/, '')}/identity/financial-migration/dm-exceptions/${rowId}/candidates`);
    return body.items ?? [];
}
export async function resolveDmException(base, rowId, assignmentId, reason) {
    return request(`${base.replace(/\/$/, '')}/identity/financial-migration/dm-exceptions/${rowId}/resolve`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ assignmentId, reason }),
    });
}
